import React from 'react';
import { Link } from 'react-router-dom';

export const DisclaimerFooter = ({ minimal = false }) => {
  if (minimal) {
    return (
      <footer className="text-center py-4 text-xs text-stone-400">
        <Link to="/privacy" className="hover:text-stone-600 hover:underline">Privacy</Link>
        <span className="mx-2">|</span>
        <Link to="/terms" className="hover:text-stone-600 hover:underline">Terms</Link>
        <span className="mx-2">|</span>
        <span>Crisis Line: 988</span>
      </footer>
    );
  }

  return (
    <footer className="bg-stone-50 border-t border-stone-200 py-8 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-6">
          <p className="text-sm text-stone-500 leading-relaxed max-w-2xl mx-auto">
            <strong>Important:</strong> Mindful Renewal and Sage are not a substitute for professional mental health treatment. 
            Sage is an AI healing companion, NOT a licensed therapist, psychologist, or medical professional.
          </p>
        </div>
        
        <div className="flex flex-wrap justify-center gap-6 text-sm text-stone-500 mb-6">
          <Link to="/privacy" className="hover:text-stone-700 hover:underline">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-stone-700 hover:underline">Terms of Service</Link>
          <a href="mailto:support@mindfulrenewaltx.com" className="hover:text-stone-700 hover:underline">Contact</a>
        </div>

        <div className="text-center text-xs text-stone-400">
          <p className="mb-2">
            <strong>If you are in crisis:</strong> Call 988 (Suicide Prevention Lifeline) | Text HOME to 741741 (Crisis Text Line) | Call 911
          </p>
          <p>&copy; {new Date().getFullYear()} Visionary Vault Ventures LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
